export default "__VITE_ASSET__mEu6k3X4__"